<template>
    <div class="begin-import"
        :style="{
            height
        }">
        <!-- upload table loading -->
        <div v-if="type === 1 && isUploading"
            class="table-uploading"
            >表格上传中...</div>
        <!-- table -->
        <el-table v-loading="type === 0 && isTableLoading"
            ref="elTable"
            :data="getTableData"
            :height="'calc(100% - 98px)'">
            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>
            <el-table-column
                prop="name"
                label="会员姓名"
                min-width="280">
                <template v-slot="{ row }">
                    <user-info v-if="type === 0"
                        :userInfo="{
                            avatar: row.avatar || '../../../../assets/images/default_avatar.svg',
                            nickname: row.nickname,
                            realname: row.realname,
                            gender: row.gender
                        }"/>
                    <p v-else class="text-popper" v-textPopper>{{ row.name }}</p>
                </template>
            </el-table-column>
            <el-table-column
                prop="phone"
                label="手机号"
                min-width="120">
            </el-table-column>
            <el-table-column
                prop="birthday"
                label="生日"
                min-width="160">
            </el-table-column>
            <el-table-column
                prop="balance"
                label="余额 (元)"
                min-width="100"
                align="right">
            </el-table-column>
            <el-table-column
                prop="point"
                label="积分"
                min-width="100"
                align="right">
            </el-table-column>
            <el-table-column
                prop="card_code"
                label="会员卡号"
                min-width="150"
                align="right">
            </el-table-column>
            <el-table-column width="20" />
            <!-- slot -->
            <template slot="empty">
                <p v-if="type === 0">暂无数据</p>
                <div v-else-if="type === 1 && !isUploading" class="table-upload">
                    <qiniu-upload :useDefault="false"
                        :accept="'.xlsx'"
                        :fileNameSuffix="'xlsx'"
                        :beforeUpload="beforeUpload"
                        :onUploadSuccess="uploadSuccess"
                        :onUploadError="uploadError">
                        <label class="align-c" for="file">
                            <i class="el-icon-plus fs-16 mb-2" />
                            <p class="lh-20">点击上传表格</p>
                        </label>
                    </qiniu-upload>
                </div>
                <div v-else />
            </template>
            <!-- append -->
            <template v-if="type === 0">
                <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                    <span class="loading-step-animation">正在加载...</span>
                </p>
                <p v-if="(!isHasMore) && getTableData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            </template>
        </el-table>
        <!-- <input v-if="type === 1"
            id="upload"
            ref="iptFile"
            type="file"
            accept=".xlsx"
            @change="fileChange"> -->
        <div class="btn-wrapper mt-20 fs-14">
            <!-- 重新上传 错误数据下载 -->
            <div v-if="type === 1" class="upload-download fx-v-center">
                <qiniu-upload v-if="getTableData.length > 0"
                    :useDefault="false"
                    :accept="'.xlsx'"
                    :beforeUpload="beforeUpload"
                    :onUploadSuccess="uploadSuccess"
                    :onUploadError="uploadError">
                    <label class="href" for="file">重新上传</label>
                </qiniu-upload>
                <span v-if="isHasBadTableData" :class="['href', 'fx-v-center', 'ml-20', { 'red-dot': !isHasExport }]" @click="exportLastExcel"><img src="../images/table_download_icon.svg" alt="">失败数据下载</span>
            </div>
            <!-- button -->
            <el-button class="import-btn color-fff"
                type="primary"
                size="medium"
                :disabled="$store.state.shop.isImportingMemberData || importDataLength === 0 || isUploading"
                @click="startImport">
                <p>{{ $store.state.shop.isImportingMemberData ? '导入中' : '开始导入' }}</p>
                <p>共{{ importDataLength }}条数据</p>
            </el-button>
            <p v-if="$store.state.shop.isImportingMemberData" class="fs-14 lh-20 mt-8 align-c color-999">温馨提示：导入过程您可以放心离开此页面，将为您保持后台会员导入进程</p>
        </div>
    </div>
</template>

<script lang="tsx">
import { createComponent, ref, computed, watch, onBeforeMount, onMounted } from '@vue/composition-api'
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'
import { openMessage, openWarning, useScrollLoad } from '../../../../utils/system'
import xlsxUtil from 'xlsx/dist/xlsx.core.min.js'
import clone from 'lodash/cloneDeep'
import $fetch from '../../../../api'
import { qiniuImageURLPrefix } from '../../../../assets/ts/qiniu'

interface IOldShopMemberListParams {
    ls_shop_id: number | string
    page?: number
}

export default createComponent({
    props: {
        // 0: 店铺导入  1: 表格导入
        type: {
            type: Number,
            default: 0
        },
        height: {
            type: String,
            default: 'calc(100vh - 390px)'
        },
        lsShopInfo: {
            type: Object
        }
    },

    setup: (props, ctx) => {
        const isTableLoading = ref(false)
        const isUploading = ref(false)
        const isHasBadTableData = ref(false)
        const isHasExport = ref(false)
        const memberCount = ref(0)
        // 表格导入的数据
        const tableImportData = ref<any[]>([])
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad,
            initScrollState
        } = useScrollLoad({
            isUseLimit: true,
            dataKey: 'member_infos'
        })

        const tableKeys = ['会员姓名', '手机号', '生日', '余额', '会员密码', '积分', '会员卡号']
        const tableKeysMap = {
            '会员姓名': 'name',
            '手机号': 'phone',
            '生日': 'birthday',
            '余额': 'balance',
            '会员密码': 'password',
            '积分': 'point',
            '会员卡号': 'card_code'
        }
        const oTableKeysMap = {
            'name': '会员姓名',
            'phone': '手机号',
            'birthday': '生日',
            'balance': '余额',
            'password': '会员密码',
            'point': '积分',
            'card_code': '会员卡号'
        }
        let tableSrc = ''
        let badSheet: any = null
        let importTableBadData:any[] = []

        const importDataLength = computed(() => {
            return memberCount.value || tableImportData.value.length
        })

        const getTableData = computed(() => {
            return tableImportData.value
        })

        watch(() => props.lsShopInfo, () => {
            if (props.type === 0) {
                initState()
                isTableLoading.value = true
                getOldShopMemberList()
                    .then(() => isTableLoading.value = false)
            }
        })

        onMounted(() => {
            if (props.type === 0) {
                bindListener({
                    dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                    loadFunction: getOldShopMemberList
                })
            }
        })

        async function getOldShopMemberList(page = oPage.value, ls_shop_id = (props.lsShopInfo || {}).ls_shop_id) {
            try {
                const params: IOldShopMemberListParams = {
                    page,
                    ls_shop_id
                }
                const result = await $fetch.post({
                    url: '/membership/migration/getlsmembers',
                    params
                })
                console.log('老零售会员列表', clone(result))
                if (page === 1) {
                    tableImportData.value = handleRecordData(result.member_infos)
                    memberCount.value = result.member_count
                    initScrollLoad(result)
                } else {
                    tableImportData.value = tableImportData.value.concat(handleRecordData(result.member_infos))
                }
                return result
            } catch (e) {
                openMessage('error', e.message || '获取老零售会员失败')
            }
        }

        async function startImport() {
            ctx.root.$store.commit('shop/setIsImportingMemberData', true)
            ctx.emit('is-importing')
            try {
                if (props.type === 0) {
                    await importShopData()
                } else {
                    await importTableData()
                }
                initState()
            } catch (e) {
                importError(e)
                if (e.code === 'IMPORT_LS_MEMBER_WITH_UNFINISHED_IMPORT') {
                    await ctx.root.$store.dispatch('shop/checkImportData')
                }
            }
        }

        async function importShopData() {
            if (props.lsShopInfo == null) {
                return openMessage('error', '店铺信息不存在，无法导入')
            }
            await $fetch.post({
                url: '/membership/migration/importlsmembers',
                params: {
                    ls_shop_id: props.lsShopInfo.ls_shop_id,
                    ls_shop_name: props.lsShopInfo.shop_name
                }
            })
            try {
                await ctx.root.$store.dispatch('shop/checkImportData')
                ctx.emit('import-success')
            } catch (e) {}
        }

        async function importTableData() {
            await $fetch.post({
                url: '/membership/migration/importmembersheet',
                params: {
                    sheet_url: tableSrc
                }
            })
            try {
                await ctx.root.$store.dispatch('shop/checkImportData')
                ctx.emit('import-success')
            } catch (e) {}
        }

        async function parseTableData(sheetJson: any[]) {
            const result = changeSheetJsonKey(sheetJson, tableKeysMap)
            const realResult = await checkTableBadData(result)

            return realResult
        }

        async function checkTableBadData(sheetJson: any[]) {
            const {
                goodArr: tableGoodData,
                badArr: tableBadData
            } = getSheetData(sheetJson)

            if (tableBadData.length > 0) {
                isHasBadTableData.value = true
                importTableBadData = badSheet || xlsxUtil.utils.json_to_sheet(changeSheetJsonKey(tableBadData, oTableKeysMap))
                await openWarning({
                    title: '系统提示',
                    type: 'primary',
                    render() {
                        return (
                            <div class="align-c">
                                <h2 class="fs-16 fw-600 lh-20 color-333">{ tableBadData.length }条数据未上传成功</h2>
                                <p class="fs-12 color-999 lh-16 mt-4">可下载修正，待本次导入完成后重新上传</p>
                            </div>
                        )
                    },
                    confirmBtnText: '下载失败数据',
                    cancelBtnText: '取消'
                }).then(() => {
                    exportLastExcel()
                }).catch(() => {
                    isHasExport.value = false
                })
            } else {
                isHasBadTableData.value = false
            }

            return tableGoodData
        }

        async function beforeUpload(file) {
            isUploading.value = true
            await fileChange(file)
        }

        function initState() {
            isTableLoading.value = false
            isUploading.value = false
            isHasBadTableData.value = false
            isHasExport.value = false
            memberCount.value = 0
            tableImportData.value = []
            tableSrc = ''
            importTableBadData = []
            initScrollState()
        }

        function handleRecordData(memberList) {
            for (let i = 0; i < memberList.length; i++) {
                memberList[i].phone = memberList[i].phone || '-'
                memberList[i].birthday = memberList[i].birthday || '-'
                memberList[i].card_code = memberList[i].card_code || '-'
            }
            return memberList
        }

        function getSheetData(sheetJson: any) {
            const goodArr: any[] = []
            let badArr: any[] = []

            if (isHasBadTableData.value) {
                badArr = clone(sheetJson)
                return {
                    goodArr,
                    badArr
                }
            }

            function judgeItemEntries(itemEntries) {
                return ['name', 'phone', 'balance'].every(item => itemEntries.find(entries => entries[0] === item))
            }

            function judgeItemEntriesValue(itemEntries) {
                return itemEntries.every(([k, v]) => {
                    let regExp
                    switch(k) {
                        case 'name':
                            regExp = /^[\d\D]{1,13}$/
                            break
                        case 'phone':
                            regExp = /^1[3456789]\d{9}$/
                            break
                        case 'birthday':
                            regExp = /^([\d]{8}|)$/
                            break
                        case 'balance':
                            regExp = /^\d+\.*\d{0,2}$/
                            break
                        case 'password':
                            regExp = /^(\d{6}|)$/
                            break
                        case 'point':
                            regExp = /^(\d*|)$/
                            break
                        case 'card_code':
                            regExp = /^(\d{4,12}|)$/
                            break
                        default:
                            break
                    }
                    if (regExp) {
                        return regExp.test(v.toString().trim())
                    } else {
                        return false
                    }
                })
            }

            sheetJson.forEach(item => {
                const itemEntries = Object.entries(item)
                const bool = judgeItemEntries(itemEntries) && judgeItemEntriesValue(itemEntries)
                bool ? goodArr.push(item) : badArr.push(item)
            })

            return {
                goodArr,
                badArr
            }
        }

        function changeSheetJsonKey(sheetJson: any[], jsonMap: { [prop: string]: string }) {
            const keys = Object.keys(jsonMap)
            function findKeys(k: string) {
                const targetKey = keys.find(key => k.includes(key))
                return {
                    isInkey: targetKey != null,
                    key: targetKey != null ? jsonMap[targetKey] : null
                }
            }
            return sheetJson.map(item => {
                const obj: { [prop: string]: any } = {}
                Object.entries(item).forEach(([k, v]) => {
                    const {
                        isInkey,
                        key
                    } = findKeys(k)
                    if (isInkey) {
                        obj[key as string] = v
                    } else {
                        obj[k] = v
                    }
                })
                return obj
            })
        }

        function exportLastExcel() {
            isHasExport.value = true
            exportExcel(importTableBadData)
        }

        function exportExcel(sheet: any) {
            const blobUrl = sheet2blob(sheet, 'errorSheet')
            beginDownload(blobUrl, '失败的会员数据表格')
        }

        function beginDownload(url, saveName) {
            if(typeof url == 'object' && url instanceof Blob) {
                url = URL.createObjectURL(url) // 创建blob地址
            }
            const aLink = document.createElement('a')
            aLink.href = url
            aLink.download = saveName + '.xlsx' || '表格.xlsx' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
            let event
            if(window.MouseEvent) {
                event = new MouseEvent('click')
            } else {
                event = document.createEvent('MouseEvents');
                event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            }
            aLink.dispatchEvent(event);
        }

        function fileChange(file) {
            return new Promise((resolve, reject) => {
                function fail() {
                    isUploading.value = false
                    reject()
                }

                readWorkbookFromLocalFile(file, async (workbook) => {
                    const sheetJson = xlsxUtil.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
                    judgeWorkbook(workbook)
                    if (sheetJson.length > 0) {
                        tableImportData.value = await parseTableData(sheetJson)
                    } else {
                        openMessage('error', '表格数据不能为空')
                        fail()
                    }
                    return tableImportData.value.length === 0 ? fail() : resolve()
                })
            })
        }

        function judgeWorkbook(workbook) {
            const sheet = workbook.Sheets[workbook.SheetNames[0]]
            const sheetKeys = Object.keys(sheet).filter(key => !key.startsWith('!'))
            console.log('sheetKeys', sheetKeys)
            isHasBadTableData.value = !sheetKeys.every(key => (key >= 'A' && key < 'H'))
            isHasBadTableData.value ? (badSheet = sheet) : (badSheet = null)
        }

        // 读取本地excel文件
        function readWorkbookFromLocalFile(file, callback) {
            const reader = new FileReader()
            reader.onload = function(e: any) {
                const data = e.target.result
                const workbook = xlsxUtil.read(data, { type: 'binary' })
                if(callback) {
                    callback(workbook)
                }
            }
            reader.readAsBinaryString(file)
        }

        // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
        function sheet2blob(sheet, sheetName) {
            sheetName = sheetName || 'sheet1'
            const workbook = {
                SheetNames: [sheetName],
                Sheets: {}
            }
            workbook.Sheets[sheetName] = sheet;
            // 生成excel的配置项
            const wopts = {
                type: 'binary',
                bookType: 'xlsx', // 要生成的文件类型
                bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
            };
            const wbout = xlsxUtil.write(workbook, wopts);
            const blob = new Blob([s2ab(wbout)], {type: "application/octet-stream"});
            // 字符串转ArrayBuffer
            function s2ab(s) {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            }

            return blob;
        }

        function uploadSuccess({ key }) {
            tableSrc = qiniuImageURLPrefix + key
            isUploading.value = false
        }

        function uploadError() {
            isUploading.value = false
        }

        function importError(e) {
            ctx.root.$store.commit('shop/setIsImportingMemberData', false)
            ctx.emit('import-error')
            openMessage('error', e.message || '导入失败')
        }

        return {
            isTableLoading,
            isHasMore,
            isScrollLoading,
            isUploading,
            isHasBadTableData,
            isHasExport,
            importDataLength,
            // computed
            getTableData,
            startImport,
            fileChange,
            exportLastExcel,
            // methods
            beforeUpload,
            uploadSuccess,
            uploadError
        }
    },

    components: {
        QiniuUpload
    }
})
</script>

<style lang="scss" scoped>
.begin-import {
    position: relative;
    text-align: center;

    .table-uploading {
        position: absolute;
        left: 0;
        top: 44px;
        right: 0;
        bottom: 98px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(151, 151, 151);
        background-color: rgba(0, 0, 0, .5);
        color: #fff;
        font-size: 14px;
        z-index: 1;
    }

    .table-upload {
        width: 100px;
        height: 50px;
        margin: 0 auto;
        font-size: 14px;

        label {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 50px;
            border: 1px dashed #ccc;
            border-radius: 4px;
            color: #333;
            line-height: 1;
            cursor: pointer;

            &:hover {
                border-color: #009688;
                color: #009688;

                i {
                    color: #009688;
                }
            }

            &:active {
                background-color: #e6f5f3;
            }

            i {
                color: #666;
                font-weight: bold;
            }
        }
    }

    input#upload {
        display: none;
    }

    .import-btn {
        width: 200px;
        height: 50px;
        padding: 0;

        > span {
            p {
                &:nth-child(1) {
                    line-height: 20px;
                }

                &:nth-child(2) {
                    line-height: 17px;
                    font-size: 12px;
                }
            }
        }
    }

    .btn-wrapper {
        position: relative;

        .upload-download {
            position: absolute;
            top: 0;
            right: 0;

            label,
            span {
                display: inline-flex;

                &.href img {
                    width: 18px;
                }
            }
        }
    }
}
</style>
